<template>
  <div class="content">
    <div class="lineBox" style="border:0px;">
      <div class="h3" @click="backToProducts()" style="float:left;margin-top:5px;cursor:pointer;">
        <font-awesome-icon style="font-siz:20px;color:#ffffff;" :icon="['fal', 'chevron-circle-left']"/>
        Produtos
      </div>
    </div>
    <div class="line">
      <div v-if="!id" class="adicionar-produto">Adicionar produto</div>
      <div v-else class="adicionar-produto">Editar produto</div>
    </div>
    <div class="line" style="border-bottom:1px solid #706C7A;"></div>
    <div class="line">
      <div class="col8">

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">EAN (caso aplicavel)</div>
          <input type="text" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.product_views[0].ean"/>
        </div>

        <div class="line">
          <div class="inputLabel">Nome</div>
          <input type="text" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.name"/>
        </div>

        <div class="line">
          <div class="inputLabel">Descrição</div>
          <!--textarea class="inputWire" style="height:100px; width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.description"></textarea-->
          <template v-if="!loadingProduct">
            <VueTrix inputId="description" v-model="product.description"/>
          </template>
        </div>

        <div class="line">
          <div class="inputLabel">Imagem</div>
          <div class="wire" style="padding:10px; min-height:100px; position:relative">
            <img v-if="getImage() !== null" :src="getImage()" style="width:300px;"/>
            <label for="selecao-arquivo">Enviar Imagem</label>
            <input id="selecao-arquivo" @change="uploadImage($event)" type="file"/>
          </div>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class>Unidades de Medida:</div>
          <div class="inputLabel">Unidade</div>
          <input type="text" class="inputWire" style="width:50%;height:30px;" :class="{'inputError': 'aaa' === true}" v-model="product.product_views[0].unit_label"/>
          <div class="inputLabel">Quantidade</div>
          <input type="number" class="inputWire" style="width:50%;height:30px;" :class="{'inputError': 'aaa' === true}" v-model.number="product.product_views[0].unit_quantity"/>
        </div>
      </div>

      <div class="col4">
        <div class="line">
          <div class="inputLabel">Produtos Relacionados:</div>
            <MultiSelect  v-model="listProducts"
                        track-by="id"
                        placeholder="Adicionar produtos"
                        selectLabel=""
                        open-direction="bottom"
                        :options="allProducts"
                        :multiple="true"
                        :searchable="true"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="false"
                        :show-no-results="true"
                        :hide-selected="true"
                        :loading="isLoading"
                        @search-change="filterSearch"
                        @select="addProductToList" style="line-height: 29px; ">
            <template slot="tag" slot-scope="{ option, remove }">
              <span class="custom__tag" style="border: solid 1px #AAAAAA;border-radius: 10px;padding: 0px 10px;margin-right: 5px;display:inline-block;margin-bottom: 3px;" ><span>{{ option.name }}</span>
                <span class="custom__remove" style="zoom: 0.9;position: relative;top: -1px;" @click="remove(option); addProductToList();">❌</span>
              </span>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc"><span class="option__title">{{ props.option.name }}</span><span class="option__small"> ({{ props.option.ean }}) </span></div>
            </template>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="listProducts.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
            </template><span slot="noResult">Nenhum resultado encontrado no filtro.</span>
          </MultiSelect>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">Preço</div>
          <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model.number="product.product_views[0].price"/>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">Preço Promocionado</div>
          <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model.number="product.product_views[0].promotional_price"/>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">Preço de Custo</div>
          <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model.number="product.product_views[0].price_cost"/>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">Atacarejo</div>
          <button @click="plusAtacarejo(product.product_views[0])"> + atacarejo</button>
          <table style="border:1px border-collapse:collapse;width:100%;" border="1" cellpadding="5">
            <tr>
              <td>Numero minimo de produtos</td>
              <td>Preço</td>
              <td>Açoes</td>
            </tr>
            <tr v-for="(atac, idxa) in product.product_views[0].promotional_conditionals" v-bind:key="idxa">
              <td>
                <input type="number" v-model.number="atac.number_of_products_to_promo" style="width:100%;height:30px;"/>
              </td>
              <td>
                <input type="number" v-model.number="atac.promotional_conditional_price" style="width:100%;height:30px"/>
              </td>
              <td>
                <button @click="removeAtacarejo(product.product_views[0], idxa)">Remover</button>
              </td>
            </tr>
          </table>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">SKU (Unidade de manutenção de estoque)</div>
          <input type="text" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.product_views[0].sku"/>
        </div>

        <div class="line" v-if="!enablePresentations">
          <div class="inputLabel">Estoque</div>
          <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model.number="product.product_views[0].stock_quantity"/>
        </div>

        <!--<div class="line">
  <div class="inputLabel">Largura em centímetros</div>
  <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.product.product_views[0].width"/>
</div>

<div class="line">
  <div class="inputLabel">Altura em centímetros</div>
  <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.product.product_views[0].height"/>
</div>

<div class="line">
  <div class="inputLabel">Profundidade em centímetros</div>
  <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.product_views[0].height"/>
</div>

<div class="line">
  <div class="inputLabel">Peso em gramas</div>
  <input type="number" class="inputWire" style="width:100%" :class="{'inputError': 'aaa' === true}" v-model="product.product_views[0].weight"/>
</div>
-->

        <div v-if="product.id" class="line" style="padding-bottom:40px;">
          ATIVAR SUB PRODUTOS?
          <br/>
          <br/> SIM:
          <input type="radio" name="enablePresentations" :value="true" v-model="enablePresentations"/> NÃO:
          <input type="radio" name="enablePresentations" :value="false" v-model="enablePresentations"/>
        </div>

        <div class="line" style="padding-bottom:40px;">
          <button class="buttonWire" style="float:left;margin:10px;width:40%;" @click="$router.push({path:'/products'})">Voltar</button>
          <button style="float:right;margin:10px;width:40%;" @click="addProductToList(); saveProduct(false, true);">Salvar</button>
        </div>

      </div>

    </div>

    <div style="clear:both;"></div>

    <!-- APRESENTACOES DE PRODUTO -->

    <template v-if="product.id && enablePresentations">
      <div class="line">
        <div class="adicionar-produto">Apresentações do Produto</div>
      </div>

      <div class="line">
        <div class="">Apresentações de produto poderão ser criadas diretamente no produto com o botão "Nova Apresentação" ou importadas do cadastro geral de Apresentações no Menu Lateral -> Apresentações. Ao criar ou importar uma nova apresentação, a lista de variações de produto será incrementada automaticamente, para ser editada. Uma apresentação é uma característica do produto com uma lista de opções. Ex:
          <br/> Apresentação: <b>Tamanho</b>, Opções: <b>P, M, G</b>
        </div>
      </div>
      <div class="line" style="border-bottom:1px solid #706C7A;"></div>

      <!-- TABELA DE APRESENTACOES DO PRODUTO -->
      <div class="line">
        <div class="col12">
          <div class="line" style="margin:15px 0px;width: 100%;">
            <button @click="openModalPresentation()" style="float:right;margin-bottom:10px;margin-left:30px;">Nova Apresentação</button>
            <button @click="openImportPresentation()" style="float:right;margin-bottom:10px;">Importar Apresentação Global</button>
            <br/>

            <table border="0" cellpadding="10" style="width:100%;border-collapse:collapse;border-color:#ffffff;margin:30px 0;" v-for="(presentation, idx) in sortedPresentations" v-bind:key="idx">
              <thead>
              <tr style="background-color:rgba(255,255,255,0.2);">
                <td border="0"><b>Nome:</b> {{presentation.name}}</td>
                <td colspan="2" border="0"><b>Mandatório:</b> {{(presentation.mandatory===true? 'sim' : 'não')}}</td>
                <td border="0" style="text-align:center;">
                  <a style="cursor:pointer;" @click="editPresentation(presentation)">
                    <font-awesome-icon style="font-siz:20px;color:#12FCC4;margin:10px;" :icon="['fal', 'edit']"/>
                  </a>
                  <a style="cursor:pointer;" @click="removePresentation(presentation)">
                    <font-awesome-icon style="font-siz:20px;color:#bb3f5c;margin:10px;" :icon="['fal', 'trash-alt']"/>
                  </a>
                </td>
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);">
                <td colspan="4"><b>Opçoes:</b></td>
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);">
                <td style="border-bottom: 1px solid;width:200px;"><i>Id</i></td>
                <td style="border-bottom: 1px solid;"><i>Descrição</i></td>
                <td style="border-bottom: 1px solid;width:150px;"><i>Cor</i></td>
                <td style="border-bottom: 1px solid;width:120px;"><i>Imagem</i></td>
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);" v-for="(option, idx2) in presentation.options" v-bind:key="idx2">
                <td style="border-bottom: 1px solid;">{{option.id}}</td>
                <td style="border-bottom: 1px solid;">{{option.label}}</td>
                <td style="border-bottom: 1px solid;" :style="{backgroundColor:option.color}">{{option.color}}</td>
                <td style="border-bottom: 1px solid;"><img v-if="option.img" :src="getOptionImagePath + option.img" style="max-width:100px;max-height:100px;"/></td>

              </tr>
              </thead>
            </table>
          </div>
        </div>

        <!-- TABELA DE VARIACOES VIEW DO PRODUTO -->

        <div class="line">
          <div class="adicionar-produto">Variações do Produto</div>
        </div>
        <div class="line">
          <div class="">Todas as combinações de apresentação de produtos devem gerar uma variação, caso contrário a combinação irá gerar o "Produto Esgotado" na loja
            <br/> Ex: Tamanhos P, M, G e Cores: Azul, Vermelho e Verde deverão gerar 9 variações de produto.
          </div>
        </div>
        <div class="line" style="border-bottom:1px solid #706C7A;"></div>

        <div class="col12">
          <div class="line" style="margin:15px 0px 50px 0px;width: 100%;">
            <button @click="openModalView()" style="float:right;">Nova Variação do Produto</button>
            <br/>
            <table border="0" cellpadding="10" style="width:100%;border-collapse:collapse;border-color:#ffffff;margin:30px 0;font-size:14px;">
              <tr style="background-color:rgba(255,255,255,0.2);">
                <td> SKU</td>
                <td> EAN</td>
                <td> Nome</td>
                <td> Ordem</td>
                <td> Qtde Estoque</td>
                <td> Apresentações</td>
                <td> Preço</td>
                <td> Preço Promocional</td>
                <td> Ativo</td>
                <td> Ações</td>
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);" v-for="(view, idxv) in product.product_views" v-bind:key="idxv">
                <td style="border-bottom: 1px solid;">{{view.sku}}</td>
                <td style="border-bottom: 1px solid;">{{view.ean}}</td>
                <td style="border-bottom: 1px solid;">{{view.name}}</td>
                <td style="border-bottom: 1px solid;">{{view.order}}</td>
                <td style="border-bottom: 1px solid;">{{view.stock_quantity}}</td>
                <td style="border-bottom: 1px solid;">
                  <ul style="margin-left:0px; padding-left:0px;">
                    <li v-for="(v, idxv) in view.view" v-bind:key="idxv" style="margin-left:0px; padding-left:0px;">
                      {{getOptionNameByView(v)}}
                    </li>
                  </ul>
                </td>
                <td style="border-bottom: 1px solid;">{{formatPrice(view.price)}}</td>
                <td style="border-bottom: 1px solid;">{{formatPrice(view.promotional_price)}}</td>
                <td style="border-bottom: 1px solid;">{{(view.active === true)?'sim': 'não'}}</td>
                <td style="border-bottom: 1px solid;">
                  <a style="cursor:pointer;" @click="openModalView(view)">
                    <font-awesome-icon style="font-siz:20px;color:#12FCC4;margin:10px;" :icon="['fal', 'edit']"/>
                  </a>
                  <template v-if="idxv > 0">
                    <a style="cursor:pointer;" @click="removeView(view)">
                      <font-awesome-icon style="font-siz:20px;color:#bb3f5c;margin:10px;" :icon="['fal', 'trash-alt']"/>
                    </a>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- IMPORT PRESENTATIONS MODAL -->
      <OpaModal width="900" height="500" v-model="importModalPresentation" header="Apresentação de Variação de Produto">
        <div style="height:320px;overflow:auto; padding:20px;">
          <table cellpadding="5" style="width:100%;border-collapse:collapse;border-color:#ffffff;" border="1">
            <tr>
              <td style="width:30px;"></td>
              <td>Nome</td>
              <td>Opções</td>
            </tr>
            <tr v-for="(globalPresentation, idxgp) in $store.state.company.presentations" v-bind:key="idxgp">
              <td>
                <input style="width:30px;height:30px;" type="checkbox" :checked="isImportChecked(globalPresentation)" @change="(e) => importCheck(e, globalPresentation)">
              </td>
              <td>{{globalPresentation.name}}</td>
              <td>
                <ul>
                  <li v-for="(globalOption, idxgo) in globalPresentation.options" v-bind:key="idxgo">
                    <div style="display:inline-flex;">
                      <div style="margin:10px;">{{globalOption.label}}</div>
                      <div v-if="globalOption.color" style="margin:10px;width:100px;height:20px;" :style="{backgroundColor: globalOption.color}">
                        {{globalOption.color}}
                      </div>
                      <div style="margin:10px;">
                        <img v-if="globalOption.img" :src="getOptionImagePath + globalOption.img" style="max-width:50px;"/>
                      </div>
                    </div>
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
        <div class="modal_footer">
          <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="importPresentations()">Importar</button>
          <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="resetImportPresentations(); importModalPresentation=!importModalPresentation">Cancelar</button>
        </div>
      </OpaModal>

      <!-- NOVA APRESENTACAO MODAL -->

      <OpaModal width="900" height="500" v-model="modalPresentation" header="Apresentação de Variação de Produto">
        <div style="height:320px;overflow:auto; padding:20px;">
          <div class="line" style="margin-top:0px;">
            <div class="col6" style="padding-top:0px;padding-bottom:0px;">
              Nome:
              <br/>
              <input type="text" class="inputText" v-model="tempPresentation.name"/>
              <br/>
              <br/>
            </div>
            <div class="col6" style="padding-top:0px;padding-bottom:0px;">
              Mandatório:
              <br/> Sim
              <input type="radio" :value="true" v-model="tempPresentation.mandatory"/> Não
              <input type="radio" :value="false" v-model="tempPresentation.mandatory"/>
              <br/>
              <br/>

            </div>
          </div>
          <div class="col12">
            Opções:
            <button @click="openModalOption()" style="width:100px;height:20px;margin-left:20px;">Nova Opção</button>
            <br/>
            <br/>
            <table border="1" style="width:100%;border-color:#ffffff;border-collapse:collapse;text-align:center;">
              <tr>
                <td>Descrição</td>
                <td>Cor</td>
                <td>Imagem</td>
                <td>Ações</td>
              </tr>
              <tbody v-if="tempPresentation.options">
              <tr v-for="(option, idx) in tempPresentation.options" v-bind:key="idx">
                <td>{{option.label}}</td>
                <td :style="{backgroundColor:option.color}">{{option.color}}</td>
                <td><img v-if="option.img" :src="getOptionImagePath + option.img" style="max-width:100px;max-height:100px;"/></td>
                <td style="text-align:center;">
                  <a @click="removeViewOption(idx)" style="cursor:pointer;">
                    <font-awesome-icon style="font-size:18px;color:#FF6767; margin:5px;" :icon="['far', 'trash-alt']"/>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal_footer">
          <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="savePresentation()">Salvar</button>
          <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="resetPresentation(); modalPresentation=false">Cancelar</button>
        </div>
      </OpaModal>

      <!-- NOVA OPCAO DE APRESENTACAO MODAL -->

      <OpaModal width="900" height="500" v-model="modalOption" header="Opção de Apresentação">
        <div style="height:320px;overflow:auto; padding:20px;">
          <div class="line" style="margin-top:0px;">
            <div class="col6" style="padding-top:0px;padding-bottom:0px;">
              Descrição:
              <br/>
              <input type="text" class="inputText" v-model="tempOption.label"/>
              <br/>
              <br/> Cor:
              <br/>
              <chrome-picker :value="colors" @input="updateColorOptionValue"></chrome-picker>
              <br/>
              <br/>
            </div>
            <div class="col6" style="padding-top:0px;padding-bottom:0px;position:relative;">
              Imagem:
              <br/>
              <OpaDragImage v-if="!tempOption.img" @uploadImage="(image) => saveOptionImage(image)"/>
              <img v-if="tempOption.img" :src="getOptionImagePath + tempOption.img" style="max-width:200px;max-height:200px;"/>
              <a v-if="tempOption.img" @click="tempOption.img = null; $forceUpdate()" style="cursor:pointer;position:absolute;top:-5px;left:100px;">
                <font-awesome-icon style="font-size:18px;color:#FF6767; margin:5px;" :icon="['far', 'trash-alt']"/>
              </a>
            </div>
          </div>
        </div>
        <div class="modal_footer">
          <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveOption()">Salvar</button>
          <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="resetOption(); modalOption=false">Cancelar</button>
        </div>
      </OpaModal>

      <!-- NOVA VARIACAO DE PRODUTO MODAL -->

      <OpaModal width="900" height="500" v-model="modalView" header="Variação de Produto">
        <div style="height:320px;overflow:auto; padding:20px;">
          <div class="line" style="margin-top:0px;">
            <div class="col6">
              EAN:
              <br/>
              <input type="text" class="inputText" v-model="tempView.ean"/>
              <br>
              <br> Nome:
              <br/>
              <input type="text" class="inputText" v-model="tempView.name"/>
              <br/>
            </div>
            <div class="col6">
              SKU:
              <br/>
              <input type="text" class="inputText" v-model="tempView.sku" style="width:370px;"/>
              <div class="line" style="margin-top:0px;">
                <div class="col4" style="margin-top:21px;padding:0px;">
                  Ordem:
                  <br/>
                  <input type="number" class="inputText" style="width:90px;" v-model.number="tempView.order"/>
                  <br/>
                </div>
                <div class="col4" style="margin-top:21px;padding:0px;margin-left:30px;">
                  Estoque:
                  <br/>
                  <input type="number" class="inputText" style="width:90px;" v-model.number="tempView.stock_quantity"/>
                  <br/>
                </div>
                <div class="col4" style="margin-top:21px;margin-left:30px;padding:0px;width:120px;">
                  Ativo:
                  <br/> Sim
                  <input type="radio" name="activeProduct" :value="true" v-model="tempView.active"/> Não
                  <input type="radio" name="activeProduct" :value="false" v-model="tempView.active"/>
                </div>
              </div>
            </div>
          </div>

          <div style="clear:both;"></div>
          <div class="line" style="margin-top:0px;">
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Preço:
              <br/>
              <input type="number" class="inputText" style="width:180px;" v-model.number="tempView.price"/>
              <br>
            </div>
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Preço Promocional:
              <br/>
              <input type="number" class="inputText" style="width:187px;" v-model.number="tempView.promotional_price"/>
              <br>
            </div>
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Preço Custo:
              <br/>
              <input type="number" class="inputText" style="width:230px;" v-model.number="tempView.price_cost"/>
              <br>
            </div>
          </div>

          <div style="clear:both;"></div>
          <div class="line" style="margin-top:15px;">
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Altura:
              <br/>
              <input type="number" class="inputText" style="width:180px;" v-model.number="tempView.height"/>
              <br>
            </div>
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Peso:
              <br/>
              <input type="number" class="inputText" style="width:187px;" v-model.number="tempView.weight"/>
              <br>
            </div>
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Largura:
              <br/>
              <input type="number" class="inputText" style="width:230px;" v-model.number="tempView.width"/>
              <br>
            </div>
          </div>

          <div style="clear:both;"></div>
          <div class="line" style="margin-top:15px;">
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Unidade de Medida:
              <br/>
              <input type="text" class="inputText" style="width:180px;" v-model.number="tempView.unit_label"/>
              <br>
            </div>
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Quantidade:
              <br/>
              <input type="number" class="inputText" style="width:187px;" v-model.number="tempView.unit_quantity"/>
              <br>
            </div>
          </div>

          <div style="clear:both;"></div>
          <div class="line">

            <div class="col8" style="padding-top:0px;padding-bottom:0px;">
              Apresentações:
              <br/>
              <table v-for="(presentation, idxA) in product.presentations" cellpadding="3" border="1" style="border-collapse:collapse;border-color:#ffffff;width:100%;margin:15px 0;" v-bind:key="idxA">
                <tr>
                  <td style="width:30px;text-align:center;"></td>
                  <td style="width:130px;">Nome</td>
                  <td style="width:80px;">Cor</td>
                  <td>Image</td>
                </tr>
                <tr v-for="(opt, idxO) in presentation.options" v-bind:key="idxO">
                  <td v-if="isPresentationOptionChecked(presentation, opt)" style="text-align:center;">
                    <input type="radio" :name="presentation.id" :value="opt.id" checked="checked" @change="setPresentationOption(presentation, opt)"/>
                  </td>
                  <td v-else style="text-align:center;">
                    <input type="radio" :name="presentation.id" :value="opt.id" @change="setPresentationOption(presentation, opt)"/>
                  </td>
                  <td>{{opt.label}}</td>
                  <td>{{opt.color}}</td>
                  <td>{{opt.img}}</td>
                </tr>
              </table>
            </div>
            <div class="col4" style="padding-top:0px;padding-bottom:0px;">
              Foto:
              <br/>
              <OpaDragImage v-if="!tempView.photos || !tempView.photos.length || !tempView.photos[0].id" @uploadImage="(image) => saveViewImage(image)"/>
              <img v-else-if="tempView.photos && tempView.photos.length && tempView.photos[0].id" :src="getViewImagePath + tempView.photos[0].id" style="max-width:200px;max-height:200px;"/>
              <a v-if="tempView.photos && tempView.photos.length && tempView.photos[0].id" @click="tempView.photos[0].id = null; $forceUpdate()" style="cursor:pointer;position:absolute;top:-5px;left:100px;">
                <font-awesome-icon style="font-size:18px;color:#FF6767; margin:5px;" :icon="['far', 'trash-alt']"/>
              </a>
            </div>
          </div>
        </div>
        <div class="modal_footer">
          <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveView()">Salvar</button>
          <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="resetView(); modalView=false">Cancelar</button>
        </div>
      </OpaModal>
    </template>

  </div>
</template>

<script>
  import VueTrix from 'vue-trix'
  import { mapGetters } from 'vuex'
  import { EventBus } from '@/utils/event-bus'
  import OpaModal from '@/components/OpaModal.vue'
  import OpaDragImage from '@/components/OpaDragImage.vue'
  import { Chrome } from 'vue-color'
  import Images from '@/connection/Images'
  import Product from '@/connection/Product'
  import formater from '@/mixins/formater'
  import searchScore from '@/mixins/searchScore'
  import _ from 'lodash'
  import Combinatorics from 'js-combinatorics'
  import productMixin from "../mixins/productMixin"
  import ProductsConn from '@/connection/Product'
  import MultiSelect from 'vue-multiselect'

  export default {
    name: 'Product',

    data() {
      return {
        colors: {
          hex: '#194d33',
          hsl: {
            h: 150,
            s: 0.5,
            l: 0.2,
            a: 1
          },
          hsv: {
            h: 150,
            s: 0.66,
            v: 0.30,
            a: 1
          },
          rgba: {
            r: 25,
            g: 77,
            b: 51,
            a: 1
          },
          a: 1
        },
        loadingProduct: true,
        id: null,
        product: {
          category_id: "0",
          name: null,
          description: null,
          active: true,
          photos: [{
            id: null,
            name: null,
            order: 0
          }],
          has_presentation: false,
          presentations: [],
          company_id: null,
          product_views: [{
            id: null,
            name: null,
            order: 0,
            stock_quantity: null,
            view: [],
            sku: null,
            ean: null,
            price_cost: 0,
            price: 0,
            promotional_price: 0,
            active: true,
            height: null,
            weight: null,
            width: null,
            photos: [],
            unit_label: null,
            max_purchase_enabled: 0,
            unit_quantity: 0
          }],
          related_ids: [],
        },
        global: {},
        tempPresentation: {
          mandatory: false
        },
        modalPresentation: false,
        modalOption: false,
        modalView: false,
        enablePresentations: false,
        importModalPresentation: false,
        selectedImportModalPresentations: [],
        isLoading: true,
        allProducts: [],
        listProducts : [],
      }
    },

    mixins: [formater, productMixin, searchScore],

    components: {
      VueTrix,
      OpaModal,
      'chrome-picker': Chrome,
      OpaDragImage,
      // OpaIcon, 
      // OpaContentEditable, 
      MultiSelect,
    },

    async created() {
      if (this.$route.params.productId && this.$route.params.productId !== '0') {
        this.id = this.$route.params.productId
        await this.getProductById(this.id)
      } else {
        console.log('not will log')
        this.loadingProduct = false
      }
      await this.getProductsIndex()
      if(this.product && this.product.related_ids && this.product.related_ids.length > 0){
        await this.fillProductsData()
      }
      this.resetPresentation()
      this.resetOption()
      this.resetView()
      this.isLoading = false
    },

    computed: {
      ...mapGetters(['getProductApi', 'getOpaApi', 'getProductsIndexApi' ]),

      sortedPresentations() {
        return this.product.presentations
      },

      getOptionImagePath() {
        return 'https://' + this.getCompany().Id + '/productImages/' + this.getCompany().companyId + '/'
      },

      getViewImagePath() {
        return 'https://' + this.getCompany().Id + '/productImages/'
      },

    },

    methods: {

      ...mapGetters(['getAdmin', 'getCompany']),

      /** PRODUCTS */

      plusAtacarejo(productView) {
        console.log(productView.promotional_conditionals)
        if (!productView.promotional_conditionals) {
          productView.promotional_conditionals = []
        }
        productView.promotional_conditionals.push({
          'promotional_conditional_price': 0,
          'number_of_products_to_promo': 0
        })
        this.$forceUpdate()
      },

      removeAtacarejo(productView, idx) {
        productView.promotional_conditionals.splice(idx, 1)
        this.$forceUpdate()
      },

      /** VIEWS */

      resetView() {
        this.tempView = {
          id: null,
          label: null,
          color: null,
          img: null
        }
      },

      openModalView(view) {
        if (this.product.presentations.length) {
          if (view) {
            this.tempView = view
            console.log(view)
          } else {
            this.tempView = _.clone(this.product.product_views[0])
            this.tempView.id = null
            this.tempView.view = []
          }
          this.modalView = true
        } else {
          EventBus.$emit('showAlert', 'error', 'Você precisa criar ou importar, ao menos uma apresentação antes')
        }
      },

      getOptionNameByView(view) {
        let name = ''
        let filteredP = this.product.presentations.filter(p => p.id === view.presentation_id)
        if (filteredP.length) {
          name = filteredP[0].options.filter(o => o.id === view.option_id)[0].label
        }
        return name
      },

      async removeView(view) {
        console.log(this.product.product_views.map(v => v.id))
        this.product.product_views = this.product.product_views.filter(v => v.id !== view.id)
        if (this.product.product_views.length > 1) {
          this.product.has_presentation = true
        } else {
          this.product.has_presentation = false
        }
        await this.saveProduct(false, false)
        this.resetView()
        this.modalView = false
      },

      async saveView() {
        if (this.validateProductViews()) {
          if (this.validateViewsOptions()) {
            if (this.tempView.id) {
              this.product.product_views.forEach((v) => {
                if (v.id === this.tempView.id) {
                  v = _.clone(this.tempView)
                }
              })
            } else {
              let v = _.clone(this.tempView)
              this.product.product_views.push(v)
            }
            if (this.product.product_views.length > 1) {
              this.product.has_presentation = true
            } else {
              this.product.has_presentation = false
            }
            await this.saveProduct(false, true)
            this.resetView()
            this.modalView = false
          } else {
            EventBus.$emit('showAlert', 'error', 'Uma outra variação de produto já possui essa combinação de opções.')
          }
        } else {
          EventBus.$emit('showLoading', false)
        }
      },

      setPresentationOption(presentation, option) {
        if (this.tempView.view && this.tempView.view.length) {
          let filtered = this.tempView.view.filter(v => v.presentation_id === presentation.id)
          if (filtered.length) {
            filtered[0].option_id = option.id
          } else {
            this.tempView.view.push({
              'presentation_id': presentation.id,
              'option_id': option.id
            })
          }
        } else {
          if (!this.tempView.view) {
            this.tempView.view = []
          }
          this.tempView.view.push({
            'presentation_id': presentation.id,
            'option_id': option.id
          })
        }
      },

      isPresentationOptionChecked(presentation, option) {
        if (this.tempView.view && this.tempView.view.length) {
          let filtered = this.tempView.view.filter(v => v.presentation_id === presentation.id && v.option_id === option.id)
          return filtered.length > 0
        } else {
          return false
        }
      },

      async updateProductViewByPresentationChange(presentationId) {
        let defaultView = _.clone(this.product.product_views[0])
        this.product.product_views = this.product.product_views.filter((v) => v.view.filter(pp => pp.presentation_id === presentationId).length === 0)
        if (!this.product.product_views.length) {
          this.product.product_views.push(defaultView)
        }
        await this.autoProductViews()
      },

      validateViewsOptions() {
        // TODO
        let ok = true
        return ok
      },

      async saveViewImage(image) {
        console.log(image)
        if (image) {
          EventBus.$emit('showLoading', true)
          let result = await Images.saveProductOptionImage(image)
          EventBus.$emit('showLoading', false)
          if (result.error) {
            alert(result.error.msg)
          } else {
            if (!this.tempView.photos) {
              this.tempView.photos = [{
                'id': null,
                'order': 1
              }]
            }
            this.tempView.photos[0] = {
              'id': this.getCompany().companyId + '/' + result,
              'order': 1
            }
            this.$forceUpdate()
          }
        }
      },

      async autoProductViews() {
        console.log('Product views length ', this.product.product_views.length)
        console.log('Presentations length ', this.product.presentations.length)
        let totalOptions = 1
        this.product.presentations.forEach(p => {
          totalOptions = totalOptions * p.options.length
        })
        let neededViews = totalOptions - this.product.product_views.length
        console.log('Total options ', totalOptions)
        console.log('Total views needed ', neededViews)
        for (let x = 0; x < neededViews; x++) {
          this.resetView()
          this.tempView = _.clone(this.product.product_views[0])
          this.tempView.id = null
          this.tempView.view = []
          await this.saveView()
          console.log('save view')
        }
        await this.cartesianProductPresentations()
        console.log('update cartesian')
        await this.saveProduct(false, true)
        console.log('save product')
      },

      async cartesianProductPresentations() {
        let allOptions = []
        this.product.presentations.forEach(p => {
          allOptions.push(p.options.map(o => p.id + '|' + o.id))
        })
        if (allOptions.length) {
          let cp = Combinatorics.cartesianProduct(...allOptions)
          let cpa = cp.toArray()
          console.log(cpa)
          // poputate all product views with a choice for each cartesianProduct combination
          for (let x = 0; x < this.product.product_views.length; x++) {
            this.product.product_views[x].view = []
            cpa[x].forEach((ops) => {
              let presOption = ops.split('|')
              this.product.product_views[x].view.push({
                'presentation_id': presOption[0],
                'option_id': presOption[1]
              })
            })
          }
        }
      },

      /** Import presentations */

      openImportPresentation() {
        this.importModalPresentation = true
      },

      async importPresentations() {
        EventBus.$emit('showLoading', true)
        this.importModalPresentation = false
        this.selectedImportModalPresentations.forEach(async (pid) => {
          let globalPresentation = this.$store.state.company.presentations.filter(p => p.id === pid)[0]
          this.tempPresentation = _.clone(globalPresentation)
          //clear original presentation id
          this.tempPresentation.id = null
          // clear original options id
          this.tempPresentation.options.forEach((o) => {
            o.id = null
          })
          console.log(this.tempPresentation)
          // save the presentation
          await this.savePresentation()
          this.resetPresentation()
        })
        this.resetImportPresentations()

        EventBus.$emit('showLoading', false)
      },

      resetImportPresentations() {
        this.selectedImportModalPresentations = []
      },

      isImportChecked(globalPresentation) {
        return this.selectedImportModalPresentations.filter(s => s === globalPresentation.id).length > 0
      },

      importCheck(e, globalPresentation) {
        let checked = e.srcElement.checked
        let filtered = this.selectedImportModalPresentations.filter(s => s === globalPresentation.id)
        if (checked && filtered.length === 0) {
          this.selectedImportModalPresentations.push(globalPresentation.id)
        } else if (!checked && filtered.length > 0) {
          let idx = this.selectedImportModalPresentations.indexOf(globalPresentation.id)
          delete this.selectedImportModalPresentations[idx]
        }
        console.log(this.selectedImportModalPresentations)
      },

      /** PRESENTATION */

      openModalPresentation() {
        this.resetPresentation()
        this.modalPresentation = true
      },

      editPresentation(presentation) {
        this.tempPresentation = presentation
        this.modalPresentation = true
      },

      resetPresentation() {
        this.tempPresentation = {
          mandatory: false
        }
      },

      async removePresentation(presentation) {
        if (confirm('Deseja excluir a apresentação? ATENÇÃO: AO REMOVER UMA APRESENTAÇÃO, TODAS AS VARIAÇÕES DE PRODUTO QUE CONTÉM ESSA APRESENTAÇÃO SERÃO REMOVIDAS AUTOMATICAMENTE.')) {
          EventBus.$emit('showLoading', true)
          let oldPresentationId = presentation.id
          this.product.presentations = this.product.presentations.filter(ap => ap.id !== presentation.id)
          EventBus.$emit('showLoading', true)
          let result = await Product.patchPresentations(this.product.presentations, this.product.id)
          EventBus.$emit('showLoading', false)
          if (result.error) {
            EventBus.$emit('showAlert', 'error', result.msg)
          } else {
            this.product.presentations = result
          }
          // remove all product views with this presentation
          await this.updateProductViewByPresentationChange(oldPresentationId)
          EventBus.$emit('showLoading', false)
        }
      },

      async savePresentation() {
        console.log(this.tempPresentation)
        EventBus.$emit('showLoading', true)
        if (!this.product.presentations) {
          this.product.presentations = []
        }
        if (!this.tempPresentation.id) {
          this.product.presentations.push(this.tempPresentation)
        }
        let result = await Product.patchPresentations(this.product.presentations, this.product.id)
        EventBus.$emit('showLoading', false)
        if (result.error) {
          EventBus.$emit('showAlert', 'error', result.msg)
          this.product.presentations.pop()
        } else {
          this.product.presentations = result
          this.resetPresentation()
          this.modalPresentation = false
        }
        // create automatic product views if has more presentations than combinations
        await this.autoProductViews()
      },

      /** OPTIONS */

      openModalOption(option) {
        if (option) {
          this.tempOption = option
        }
        this.modalOption = true
      },

      resetOption() {
        this.tempOption = {
          id: null,
          label: null,
          color: null,
          img: null
        }
      },

      updateColorOptionValue(val) {
        console.log(val.hex)
        this.tempOption.color = val.hex
      },

      async saveOptionImage(image) {
        if (image) {
          EventBus.$emit('showLoading', true)
          let result = await Images.saveProductOptionImage(image)
          EventBus.$emit('showLoading', false)
          if (result.error) {
            alert(result.error.msg)
          } else {
            this.tempOption.img = result
            this.$forceUpdate()
          }
        }
      },

      saveOption() {
        console.log(this.tempOption)
        if (!this.tempPresentation.options) {
          this.tempPresentation.options = []
        }
        this.tempPresentation.options.push(this.tempOption)
        this.resetOption()
        this.modalOption = !this.modalOption
      },

      removeViewOption(idx) {
        console.log(idx)
        this.tempPresentation.options.splice(idx, 1)
        this.$forceUpdate()
      },

       async getProductsIndex () {
        this.loading = true
        let r = await ProductsConn.getProductsIndex()
        if (!r.error) {
          this.allProductsFull = r.map((product) => {
            product.text = product.name
            product.value = product.id
            return product
          })
          this.allProducts = _.clone(this.allProductsFull)
        } else {
          console.log('error', r)
        }
      },

      fillProductsData () {
        //Fill product list with all product information
        let vm = this
        this.product.related_ids.forEach(related_id => {
          //Get products with order inside list
          let found = vm.allProducts.find(p => p.id === related_id)
          if (found){
            let product = found
            vm.listProducts.push(product)
          }

        })
        this.$forceUpdate()
      },

      addProductToList () {
        this.product.related_ids = !this.product.related_ids ? [] : this.product.related_ids
        this.$forceUpdate()
        this.product.related_ids = this.listProducts.map (product => product.id)
        this.$forceUpdate()
      },

      filterSearch(searchQuery) {
        if (searchQuery.length < 2) {
          this.allProducts = this.allProductsFull
          return;
        }
        this.allProducts = this.filterIndexedProduct(this.allProductsFull, searchQuery, -1, true, true).productList
      },
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style> 
<style lang="scss" scoped>
  .adicionar-produto {
    color: #12FCC4;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
  }

  .inputLabel {
    color: #FFFFFF;
    font-family: Roboto;
    font-size: 14px;
    margin-bottom: 10px;
  }

  /* Esconde o input */

  input[type='file'] {
    display: none;
  }

  label {
    width: 120px;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    text-decoration: underline;
    color: #12FCC4;
    font-family: Roboto;
    font-size: 14px;
  }
</style>
